export default __webpack_public_path__ + "static/media/ProximaNova-Semibold.3a349136.woff2";